import { gql } from '@apollo/client'

import { FRAGMENT_SENTIMENT, FRAGMENT_SENTIMENT_POSTS } from '../fragments/sentiment'
import { FRAGMENT_WORKSPACE } from '../fragments/workspace'
import { FRAGMENT_WORKSPACE_BRAND } from '../fragments/workspaceBrand'

export const GET_WORKSPACE_SENTIMENT = gql`
  query getWorkspaceSentiment($filters: TerritorySentimentTitleFilters, $filtersPosts: TerritoryMostEngagedFilters) {
    getWorkspace {
      ...FragmentWorkspace
      workspaceBrand {
        ...FragmentWorkspaceBrand
        workspaceBrandTerritories {
          earnedTerritory {
            territoryId
            ...FragmentSentiment
            ...FragmentSentimentPosts
          }
        }
      }
    }
  }
  ${FRAGMENT_WORKSPACE}
  ${FRAGMENT_SENTIMENT}
  ${FRAGMENT_SENTIMENT_POSTS}
  ${FRAGMENT_WORKSPACE_BRAND}
`
